import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getTokenInCookie } from '@/utils/index' // get token from cookie

const unurl = process.env.NODE_ENV == 'production' ? 'http://oa.univ-bio.com' : 'http://oatest.univ-bio.com'
NProgress.configure({ showSpinner: false })
router.beforeEach(async(to, from, next) => {
  // determine whether the user has logged in
  NProgress.start()
  const hasToken = getTokenInCookie()
  if (hasToken) {
    const hasName = store.getters.userName
    if (hasName) {
      next()
    } else {
      try {
        // get user info
        await store.dispatch('user/getInfo')
        await store.dispatch('user/getMenus')
        next()
      } catch (error) {
        Message.error('请重新登录')
        window.location.href = unurl+'/Home/Common/Login/logout'
      }
    }
  } else {
    /* has no token回登录页重新登录*/ 
      Message.error('请重新登录')
      window.location.href = unurl+'/Home/Common/Login/logout'
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})




// WEBPACK FOOTER //
// ./src/permission.js